import React from 'react';
import classNames from 'classnames';
import bugsnagReact from '@bugsnag/plugin-react';

import { TranslatedMessage } from 'common/components/Intl';

const getBugsnagErrorBoundary = () => {
  window.bugsnagClient.use(bugsnagReact, React);
  return window.bugsnagClient.getPlugin('react');
};

const BASE_COMPONENT =
  typeof window.bugsnagClient !== 'undefined'
    ? getBugsnagErrorBoundary()
    : React.Component;

export default class ErrorBoundary extends BASE_COMPONENT {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    super.componentDidCatch && super.componentDidCatch(error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className={classNames('container-fluid', this.props.className)}>
          <div className="row center-xs">
            <div className="col-xs-10 col-sm-6 col-md-4 col-lg-3 no-padding left">
              <h1>
                {' '}
                <TranslatedMessage id={'common.error_boundary.title'} />{' '}
              </h1>
              <p>
                <TranslatedMessage id={'common.error_boundary.description'} />
              </p>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
